import { render, staticRenderFns } from "./BaseSetting.vue?vue&type=template&id=f6709922&scoped=true&"
import script from "./BaseSetting.vue?vue&type=script&lang=js&"
export * from "./BaseSetting.vue?vue&type=script&lang=js&"
import style0 from "./BaseSetting.vue?vue&type=style&index=0&id=f6709922&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6709922",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6709922')) {
      api.createRecord('f6709922', component.options)
    } else {
      api.reload('f6709922', component.options)
    }
    module.hot.accept("./BaseSetting.vue?vue&type=template&id=f6709922&scoped=true&", function () {
      api.rerender('f6709922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/settings/BaseSetting.vue"
export default component.exports